import { ArrowRight } from 'lucide-react';

const MILESTONES = [
  { year: '2022', text: 'Started building trading systems and network tools' },
  { year: '2024', text: 'Adopted AI-augmented development workflows' },
  { year: '2025', text: 'Founded Feral Techlabs — AI-powered agency model' },
  { year: '2026', text: '15 iOS apps, 4 platforms, 8-person team' },
];

const STATS = [
  { v: '15+', l: 'Apps built' },
  { v: '4', l: 'Platforms shipped' },
  { v: '8', l: 'Team members' },
  { v: '0', l: 'Missed deadlines' },
];

const About = () => (
  <section className="r-section about" id="about">
    <div className="r-wrap">
      <div className="about-grid">
        <div className="r-reveal">
          <div className="r-tag">About</div>
          <h2 className="r-head" style={{ marginBottom: '24px' }}>
            Built different. <span className="r-gtxt">On purpose.</span>
          </h2>
          <div className="about-copy">
            <p>
              Feral Techlabs is a modern software agency that leverages AI-augmented
              workflows to deliver the output of a 20-person team at a fraction of the
              cost and time.
            </p>
            <p>
              We didn&apos;t set out to build an agency. We set out to build great software —
              trading platforms, security tools, mobile apps — and realized the best way to
              do it was to rethink how teams work. Every team member is a specialist, equipped
              with AI-powered tools that 10x their output.
            </p>
            <p>
              The result: we ship faster, think deeper, and never miss a deadline. Not because
              we work harder — because we work smarter.
            </p>
          </div>
          <div className="about-cta">
            <a href="#contact" className="btn-primary fh-cta">
              <span>Work with us</span>
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="r-reveal r-d1">
          <div className="about-timeline">
            {MILESTONES.map((m, i) => {
              const isLast = i === MILESTONES.length - 1;
              return (
                <div key={m.year} className={`about-ms ${isLast ? 'is-last' : ''}`}>
                  {!isLast && <span className="about-ms-line" />}
                  <span className="about-ms-dot" />
                  <div className="about-ms-year">{m.year}</div>
                  <div className="about-ms-text">{m.text}</div>
                </div>
              );
            })}
          </div>
          <div className="about-stats">
            {STATS.map((s) => (
              <div key={s.l} className="about-stat">
                <div className="about-stat-v">{s.v}</div>
                <div className="about-stat-l">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default About;
